import { ComponentRef } from '@angular/core';

export function setComponentInputs(
  component: ComponentRef<any>,
  data: Record<string, any>
): void {
  Object.entries(data).forEach(([key, value]) => {
    Object.assign(component.instance, { [key]: value });
  });
}
